import { render, staticRenderFns } from "./family_info_summary.vue?vue&type=template&id=5c19b96a&"
import script from "./family_info_summary.vue?vue&type=script&lang=js&"
export * from "./family_info_summary.vue?vue&type=script&lang=js&"
import style0 from "./family_info_summary.vue?vue&type=style&index=0&id=5c19b96a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports